import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";

const PWD_REGEX = /^(?=).{8,24}$/;

const RegisterComp = () => {
  const { setUserData } = useContext(UserContext);
  const errRef = useRef();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);

  const [matchPassword, setMatchPassword] = useState("");
  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    const result = PWD_REGEX.test(password);
    setValidPassword(result);
    const match = password === matchPassword;
    setValidMatch(match);
  }, [password, matchPassword]);

  useEffect(() => {
    setErrMsg("");
  }, [password, matchPassword]);

  const registerUser = async (e) => {
    e.preventDefault();
    const pwdErr = PWD_REGEX.test(password);
    if (!pwdErr) {
      setErrMsg("Password must be up to 8 Characters");
      return;
    }

    const newUser = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
    };

    await axiosUrl
      .post("/users/register", newUser)
      .then((res) => {
        console.log(res.data);
        alert("Registration Successful!!!");
      })
      .catch((err) => {
        if (!err?.response) {
          setErrMsg("Oops No Server Response.. Pls try again later...");
        } else if (errMsg.response?.status === 409) {
          setErrMsg("Email Already Exist");
        } else {
          setErrMsg("Registration Failed.. Try again later...");
          return;
        }
      });

    try {
      const User = {
        email: email,
        password: password,
      };
      const loginResponse = await axiosUrl.post("/users/login", User);

      setUserData({
        token: loginResponse.data.token,
        user: loginResponse.data.user,
      });
      localStorage.setItem("auth-token", loginResponse.data.token);
      window.location.href = "/dashboard";
    } catch (err) {}
  };

  return (
    <form onSubmit={registerUser}>
      <div className="inner">
        <p
          ref={errRef}
          className={errMsg ? "d-block" : "d-none"}
          style={{ color: "red", marginBottom: "1rem" }}
        >
          <i className="fas fa-info-circle mx-2"></i>
          {errMsg}
        </p>
        <div className="custom-group">
          <div className="form-group">
            <label htmlFor="firstname">First Name</label>
            <input
              type="text"
              id="firstname"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastname">Last Name</label>
            <input
              type="text"
              id="lastname"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="Email">Email</label>
          <input
            type="email"
            id="Email"
            placeholder="investor@xyz.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="custom-group">
          <div className="form-group">
            <div className="password-label">
              <label htmlFor="password">Password</label>
            </div>
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              onFocus={() => setPasswordFocus(true)}
              onBlur={() => setPasswordFocus(false)}
            />
            <small
              className={`mt-2 ${
                passwordFocus && !validPassword ? "d-block" : "d-none"
              }`}
              style={{ color: "red" }}
            >
              <i className="fas fa-info-circle "></i> Must be 8 to 24 characters
            </small>
          </div>{" "}
          <div className="form-group">
            <div className="match-password-label">
              <label htmlFor="matchPassword">Confirm Password</label>
            </div>
            <input
              type="password"
              id="matchPassword"
              placeholder="Confirm Password"
              value={matchPassword}
              onChange={(e) => setMatchPassword(e.target.value)}
              required
              onFocus={() => setMatchFocus(true)}
              onBlur={() => setMatchFocus(false)}
            />
            <small
              className={`mt-2 ${
                matchFocus && !validMatch ? "d-block" : "d-none"
              }`}
              style={{ color: "red" }}
            >
              <i className="fas fa-info-circle "></i> Passwords must match
            </small>
          </div>
        </div>

        <div className="submit-btn">
          <input
            className="btn"
            type="submit"
            value="CREATE ACCOUNT"
            disabled={
              !firstName || !lastName || !email || !validPassword || !validMatch
                ? true
                : false
            }
          />
        </div>

        <label className="new-member">
          Already have an account?{" "}
          <Link to="/login">
            <span>SIGN IN</span>
          </Link>
        </label>
      </div>
    </form>
  );
};

export default RegisterComp;
